import { memo } from 'react';
import clsx from 'clsx';
import { useHolidayBanner } from './useHolidayBanner';
import s from './HolidayBanner.module.scss';

export interface HolidayBannerProps {
  className?: string;
}

export const HolidayBanner = memo(({ className }: HolidayBannerProps) => {
  const { banner } = useHolidayBanner();

  if (!banner) {
    return null;
  }

  if (banner.type === 'link' && banner.imageUrl) {
    return (
      <a
        className={clsx(s.HolidayBanner, s.HolidayBanner_link, className)}
        href={banner.imageUrl}
        target="_blank"
        rel="noopener noreferrer">
        {banner.title}
      </a>
    );
  }

  return <span className={clsx(s.HolidayBanner, s.HolidayBanner_text, className)}>{banner.title}</span>;
});

HolidayBanner.displayName = 'HolidayBanner';
